import { Component, forwardRef } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../utils/pagination";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../actions/fillCombo_action';
import AdminDrawer from "../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import { getDRCDetails_action, insertUpdateDRC_action } from "../../../actions/admin_module_action/daily_routine_checklist_action/daily_routine_checklist_action";
import { exhibitionId, serviceTypeId, toastError, contractorListActionId, toastSuccess, responsiblePersonListctionId, vendorListId, HallZoneActionId, HallListActionId, HallZoneListActionId } from "../../../utils/constants";
import Select from 'react-select';
import Modal from "react-modal";
import { data } from "jquery";
// import 'bootstrap-icons/font/bootstrap-icons.css';
import DatePicker from "react-datepicker";
import {
    contactNoValidator,
    panNoValidator,
    tanNoValidator,
    gstNoValidator,
    emailValidator,
} from "../../../utils/Validator";
import Resizer from "react-image-file-resizer";
import ImageCapture from '../../../utils/ImageCapture';
import moment from 'moment';
// import { TimePicker } from '@mui/x-date-pickers/TimePicker';

class DailyRoutineChecklistSetup extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            DailyRoutineChecklistHdrID: '',
            title: '',
            fromDate: '',
            toDate: '',
            preAlertTime: '',
            scheduleStartTime: '',
            scheduleEndTime: '',
            scheduleTimeList: [],
            vendorList: [],
            specificPersonList: [],
            selectedspecificPersonList: [],
            hallList: [],
            areaSelect: '',
            rPersonToggle: '',
            rPersonID: '',
            DRCList: [{ srno: 1, parentId: null, parentSrno: null, desc: '', addInt: '', startTime: '', endTime: '', AccountID: '', DailyRoutineChecklistDetailID: '', ChecklistStatusID: '' }],

            titleErr: '',
            fromDateErr: '',
            toDateErr: '',
            preAlertTimeErr: '',
            scheduleTimeListErr: '',
            hallListErr: '',
            rPersonIDErr: '',
            DRCListErr: '',
            onhighTime: false
        }
        this.onAddScheduleTime = this.onAddScheduleTime.bind(this)
        this.onRemoveScheduleTime = this.onRemoveScheduleTime.bind(this)
        this.oncheckHall = this.oncheckHall.bind(this)
        this.editChecklist = this.editChecklist.bind(this)
        this.addMainTask = this.addMainTask.bind(this)
        this.addSubTask = this.addSubTask.bind(this)
        this.onDeleteChecklist = this.onDeleteChecklist.bind(this)
        this.getDRCDetails = this.getDRCDetails.bind(this)
        this.insertUpdateDRC = this.insertUpdateDRC.bind(this)
        this.checkTime = this.checkTime.bind(this)
    }

    componentDidMount() {
        this.getFillList(HallListActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '').then(() => {
            this.getFillList(vendorListId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '').then(() => {
                this.getFillList(responsiblePersonListctionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '').then(() => {
                    if (this.props.location.state != null && this.props.location.state.DailyRoutineChecklistHdrID != null && this.props.location.state.DailyRoutineChecklistHdrID != undefined) {
                        this.setState({
                            DailyRoutineChecklistHdrID: this.props.location.state.DailyRoutineChecklistHdrID,
                        })
                        this.getDRCDetails(this.props.location.state.DailyRoutineChecklistHdrID)
                    }
                })
            })
        })
    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID) {
        const { } = this.state
        return new Promise((resolve, reject) => {

            this.props
                .fill_action(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID)
                .then((data) => {
                    if (data.error != 1) {
                        // voucher list
                        if (actionID === HallListActionId) {
                            data.data.map(item => {
                                item.isSelect = false
                                item.DailyRoutineChecklistHallID = ''
                                item.UserID = ''
                            })
                            this.setState({ hallList: data.data })
                            resolve()

                        }
                        if (actionID === vendorListId) {
                            this.setState({ vendorList: data.data })
                            resolve()

                        } if (actionID === responsiblePersonListctionId) {
                            this.setState({ specificPersonList: data.data })
                            resolve()

                        }
                    }
                })
        })
    }


    getDRCDetails(id) {
        const { isLoading, title, DRCList, fromDate, toDate, scheduleTimeList, hallList, DailyRoutineChecklistHdrID, Area, Rperson, AreaList, RpList } = this.state
        this.setState({ isLoading: true })
        this.props.getDRCDetails_action(id)
            .then((data) => {
                if (data.error != 1) {
                    if (data.data[0].length > 0) {
                        var toggle = data.data[0][0].isHallManager ? 1 : 2
                        this.setState({
                            title: data.data[0][0].ProgramTitle,
                            fromDate: data.data[0][0].FromDate != '' ? new Date(data.data[0][0].FromDate) : '',
                            preAlertTime: data.data[0][0].PreAlertTime,
                            toDate: data.data[0][0].ToDate != '' ? new Date(data.data[0][0].ToDate) : '',
                            rPersonToggle: data.data[0][0].isHallManager ? 1 : 2,
                            // VendorDetailsNo: data.data[0][0].VendorMobileNo, moment(toDate).format('YYYY-MM-DD')
                        })
                    }
                    setTimeout(() => {
                        console.log(new Date(data.data[0][0].FromDate))
                    }, 500);
                    if (data.data[1].length > 0) {
                        for (var i = 0; i < data.data[1].length; i++) {
                            scheduleTimeList.push({ scheduleStartTime: data.data[1][i].FromTime, scheduleEndTime: data.data[1][i].ToTime, DailyRoutineChecklistScheduleTimeID: data.data[1][i].DailyRoutineChecklistScheduleTimeID })
                        }
                        this.setState({
                            scheduleTimeList: scheduleTimeList,
                        })
                    }
                    if (data.data[2].length > 0) {
                        var accid = ''
                        for (var i = 0; i < data.data[2].length; i++) {
                            hallList.map(item => {
                                if (data.data[2][i].HallID == item.HallId) {
                                    item.isSelect = true
                                    item.DailyRoutineChecklistHallID = data.data[2][i].DailyRoutineChecklistHallID
                                    accid = data.data[2][i].UserID
                                }
                            })
                        }
                        if (toggle == 2) {
                            // RpList.map(item => {
                            //     if (item.AccountID == accid) {
                            //         item.isSelect = true
                            //     }
                            // })
                            this.setState({ rPersonID: accid })
                        }
                        this.setState({
                            hallList: hallList
                        })
                    }
                    var tempCheckList = []
                    if (data.data[3].length > 0) {
                        for (var i = 0; i < data.data[3].length; i++) {
                            var obj = { srno: data.data[3][i].SrNo, parentId: data.data[3][i].ParentChecklist, parentSrno: data.data[3][i].ParentSrno, desc: data.data[3][i].ChecklistDescription, addInt: data.data[3][i].AdditionalInstruction, startTime: data.data[3][i].StartTime, endTime: data.data[3][i].EndTime, AccountID: data.data[3][i].ChecklistAssignID, DailyRoutineChecklistDetailID: data.data[3][i].DailyRoutineChecklistDetailID, ChecklistStatusID: '' }
                            tempCheckList.push(obj)
                        }
                        this.setState({ DRCList: tempCheckList })
                    }
                    this.setState({ isLoading: false })
                } else {
                    toastError('Something went wrong...')
                    this.setState({ isLoading: false })

                }
            })
            .catch((err) => {
                console.log(err)
            })
    }


    // onAddScheduleTime() {
    //     const { isLoading, isOpen, title, fromDate, toDate, preAlertTime, scheduleStartTime, scheduleEndTime, scheduleTimeList, areaSelect, rPersonToggle, rPersonID, DRCList } = this.state
    //     var errAlready = false
    //     if (scheduleEndTime == '' || scheduleEndTime == null) {
    //         errAlready = true
    //         toastError("Please enter schedule end time")
    //     } else {
    //         scheduleTimeList.push({ scheduleStartTime: scheduleStartTime, scheduleEndTime: scheduleEndTime, DailyRoutineChecklistScheduleTimeID: null })
    //         this.setState({ scheduleTimeList: scheduleTimeList, scheduleStartTime: '', scheduleEndTime: '', scheduleTimeListErr: '' })
    //     }
    // }

    onAddScheduleTime() {
        const { isLoading, isOpen, title, fromDate, toDate, preAlertTime, scheduleStartTime, scheduleEndTime, scheduleTimeList, areaSelect, rPersonToggle, rPersonID, DRCList, onhighTime } = this.state
        var errAlready = false
        //  else {
        setTimeout(() => {
            if (onhighTime) {
                // if (!errAlready) {
                scheduleTimeList.splice(scheduleTimeList.length, 1)
                this.setState({ scheduleTimeList: scheduleTimeList, onhighTime: false })
            } else {
                // else {
                if (scheduleEndTime == '' || scheduleEndTime == null) {
                    errAlready = true
                    toastError("Please enter schedule end time")
                } else {
                    scheduleTimeList.push({ scheduleStartTime: scheduleStartTime, scheduleEndTime: scheduleEndTime, DailyRoutineChecklistScheduleTimeID: null })
                    this.setState({ scheduleTimeList: scheduleTimeList, scheduleStartTime: '', scheduleEndTime: '', scheduleTimeListErr: '' })
                }
                // }
            }
        }, 1000);


    }
    onRemoveScheduleTime(i) {
        const { isLoading, isOpen, title, fromDate, toDate, preAlertTime, scheduleStartTime, scheduleEndTime, scheduleTimeList, areaSelect, rPersonToggle, rPersonID, DRCList } = this.state
        scheduleTimeList.splice(i, 1)
        this.setState({ scheduleTimeList: scheduleTimeList })
    }
    oncheckHall(id) {
        const { isLoading, hallList, isOpen, title, fromDate, toDate, preAlertTime, scheduleStartTime, scheduleEndTime, scheduleTimeList, areaSelect, rPersonToggle, rPersonID, DRCList } = this.state
        hallList.map(item => {
            if (item.HallId == id) {
                if (item.isSelect == true) {
                    item.isSelect = false
                } else {
                    item.isSelect = true
                }
            }
        })
        this.setState({ hallList: hallList, hallListErr: '', })
    }

    addMainTask() {
        const { isLoading, specificPersonList, hallList, isOpen, title, fromDate, toDate, preAlertTime, scheduleStartTime, scheduleEndTime, scheduleTimeList, areaSelect, rPersonToggle, rPersonID, DRCList } = this.state
        var newSr = 0
        DRCList.map(item => {
            if (item.parentId == null) {
                newSr = newSr + 1
            }
        })
        DRCList.push({ srno: newSr + 1, parentId: null, desc: '', parentSrno: null, addInt: '', startTime: '', endTime: '', DailyRoutineChecklistDetailID: '', AccountID: '', ChecklistStatusID: '' })
        this.setState({ DRCList: DRCList })
    }

    addSubTask(id) {
        const { isLoading, specificPersonList, hallList, isOpen, title, fromDate, toDate, preAlertTime, scheduleStartTime, scheduleEndTime, scheduleTimeList, areaSelect, rPersonToggle, rPersonID, DRCList } = this.state
        var parInd = 0
        var parId = 0
        DRCList.map((item, i) => {
            if (item.srno == id) {
                parInd = i
                parId = item.DailyRoutineChecklistDetailID
            }
        })
        var totalSub = 0
        DRCList.map((item, i) => {
            if (item.parentSrno != null) {
                if (id == item.parentSrno) {
                    totalSub = totalSub + 1
                }
            }
        })
        DRCList.splice(parInd + totalSub + 1, 0, { srno: `${id}.${totalSub + 1}`, DailyRoutineChecklistDetailID: '', parentId: parId, desc: '', addInt: '', startTime: '', endTime: '', AccountID: '', ChecklistStatusID: '', parentSrno: id, })
        this.setState({ DRCList: DRCList })
    }

    editChecklist(value, id, mode) {
        const { isLoading, specificPersonList, hallList, isOpen, title, fromDate, toDate, preAlertTime, scheduleStartTime, scheduleEndTime, scheduleTimeList, areaSelect, rPersonToggle, rPersonID, DRCList } = this.state
        if (mode == 0) {
            DRCList[id].desc = value
        } else if (mode == 1) {
            DRCList[id].addInt = value
        } else if (mode == 2) {
            DRCList[id].startTime = value
        } else if (mode == 3) {
            DRCList[id].endTime = value
        } else if (mode == 4) {
            DRCList[id].AccountID = value
        }
        console.log(DRCList[id])
        this.setState({ DRCList: DRCList, DRCListErr: '' })
    }

    insertUpdateDRC() {
        const { isLoading, specificPersonList, DailyRoutineChecklistHdrID, hallList, isOpen, title, fromDate, toDate, preAlertTime, scheduleStartTime, scheduleEndTime, scheduleTimeList, areaSelect, rPersonToggle, rPersonID, selectedspecificPersonList, DRCList } = this.state
        var Err = false
        if (title == '' || title == null) {
            this.setState({ titleErr: 'Please Enter Title' })
            Err = true
        }
        if (fromDate == '' || fromDate == null) {
            this.setState({ fromDateErr: 'Please Enter From Date' })
            Err = true
        }
        if (toDate == '' || toDate == null) {
            this.setState({ toDateErr: 'Please Enter To Date' })
            Err = true
        }
        if (preAlertTime == '' || preAlertTime == null) {
            this.setState({ preAlertTimeErr: 'Please Enter pre altert time' })
            Err = true
        }
        if (scheduleTimeList.length == 0) {
            this.setState({ scheduleTimeListErr: 'Please Enter Schedule time' })
            Err = true
        }
        var selectedHallList = []
        for (var i = 0; i < hallList.length; i++) {
            if (hallList[i].isSelect) {
                selectedHallList.push(hallList[i].HallName)
            }
        }
        if (selectedHallList.length == 0) {
            this.setState({ hallListErr: 'Please select area' })
            Err = true
        }
        if (rPersonToggle == '' || rPersonToggle == null) {
            this.setState({ rPersonIDErr: 'Please Select Responsible person' })
            Err = true
        } else {
            if (rPersonToggle == 2) {
                if (selectedspecificPersonList.length == 0) {
                    this.setState({ rPersonIDErr: 'Please Select atleast 1 Responsible person' })
                    Err = true
                }
            }
        }
        for (var i = 0; i < DRCList.length; i++) {
            if (DRCList[i].desc == '') {
                this.setState({ DRCListErr: 'Please Enter Description' })
                Err = true
            }
            if (DRCList[i].startTime == '') {
                this.setState({ DRCListErr: 'Please Enter Start Time' })
                Err = true
            }
            if (DRCList[i].endTime == '') {
                this.setState({ DRCListErr: 'Please Enter End Time' })
                Err = true
            }
            if (DRCList[i].AccountID == '') {
                this.setState({ DRCListErr: 'Please Select Service Partner' })
                Err = true
            }
        }
        const inputToDate = new Date(toDate);
        const today = new Date();

        // Remove time part for an exact date-only comparison
        today.setHours(0, 0, 0, 0);
        inputToDate.setHours(0, 0, 0, 0);

        if (inputToDate < today) {
            return toastError("The selected To date has already passed. Please choose a valid future To date before submitting")
        }
        setTimeout(() => {
            if (!Err) {
                var tempHallList = hallList.filter(item => item.isSelect)
                var hallList2 = []
                tempHallList.map(item => {
                    if (rPersonToggle == 2) {
                        selectedspecificPersonList.map((item2) => {
                            var obj = { DailyRoutineChecklistHallID: '', HallId: item.HallId, UserID: item2.value }
                            // item.UserID = item2.value
                            hallList2.push(obj)
                        })
                    } else {
                        var obj = { DailyRoutineChecklistHallID: '', HallId: item.HallId, UserID: '' }
                        // item.UserID = item2.value
                        hallList2.push(obj)
                    }
                })
                var timeArr = []
                scheduleTimeList.map(item => {
                    timeArr.push(item.scheduleStartTime != '' && item.scheduleStartTime != null ? `${item.scheduleStartTime}-${item.scheduleEndTime}` : `${item.scheduleEndTime}`)
                })

                // scheduleTimeList.map(item => {
                // })
                console.log(hallList2, tempHallList)
                this.setState({ isLoading: true })
                this.props.insertUpdateDRC_action(DailyRoutineChecklistHdrID != '' && DailyRoutineChecklistHdrID != null ? DailyRoutineChecklistHdrID : null, title, moment(fromDate).format('YYYY-MM-DD'), moment(toDate).format('YYYY-MM-DD'), preAlertTime, timeArr.toString(), selectedHallList.toString(), rPersonToggle == 1 ? true : false, scheduleTimeList, hallList2, DRCList)
                    .then((data) => {
                        if (data.error != 1) {
                            // if (data.data.length > 0) {
                            // if (data.data[0].length > 0) {
                            // this.setState({ DDreturnListArr: data.data, })
                            // }
                            // }
                            toastSuccess("Updated successfully")
                            setTimeout(() => {
                                this.props.navigate('/dailyRoutineChecklistList')
                            }, 1000);
                            // this.setState({ isLoading: false })
                        } else {
                            toastError(data.msg)
                            this.setState({ isLoading: false })
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            } else {
                toastError("Enter mandatory fields")
            }
        }, 200);
    }

    onDeleteChecklist(id, mode) {
        const { isLoading, specificPersonList, hallList, isOpen, title, fromDate, toDate, preAlertTime, scheduleStartTime, scheduleEndTime, scheduleTimeList, areaSelect, rPersonToggle, rPersonID, DRCList } = this.state
        if (mode == 1) {
            DRCList.splice(id, 1)
        } else {
            var parid = ''
            DRCList.map((item, i) => {
                if (id == i) {
                    parid = item.id
                }
            })
            var totalSub = 0
            DRCList.map((item, i) => {
                if (item.parentId != null) {
                    if (parid == item.parentId) {
                        totalSub = totalSub + 1
                    }
                }
            })
            DRCList.splice(id, totalSub + 1)
        }
        var newSr = 0
        var subcount = 0
        DRCList.map((item, i) => {
            if (item.parentId == null) {
                item.id = newSr + 1
                item.srno = newSr + 1
                newSr = newSr + 1
                subcount = 0
            } else {
                item.id = `${newSr}.${subcount + 1}`
                item.srno = `${newSr}.${subcount + 1}`
                subcount = subcount + 1
            }
        })
        this.setState({ DRCList: DRCList })
    }

    checkTime(mode, flag) {
        const { isLoading, vendorList, specificPersonList, hallList, isOpen, title, fromDate, toDate, preAlertTime, scheduleStartTime, scheduleEndTime, scheduleTimeList, areaSelect, rPersonToggle, rPersonID, DRCList, titleErr, fromDateErr, toDateErr, preAlertTimeErr, scheduleTimeListErr, hallListErr, rPersonIDErr, DRCListErr, } = this.state
        const today = new Date();
        const d1 = fromDate != null && fromDate != '' ? new Date(fromDate) : ''
        const d2 = toDate != null && toDate != '' ? new Date(toDate) : ''
        return new Promise((resolve, reject) => {
            var err = false
            var diffDays = ''
            if (d1 != '' && d2 != '') {
                const diffTime = Math.abs(d2 - d1); // difference in milliseconds
                diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            }
            if (diffDays == 0) {
                if (fromDate != '') {
                    if (new Date(fromDate).getDate() === today.getDate() &&
                        new Date(fromDate).getMonth() === today.getMonth() &&
                        new Date(fromDate).getFullYear() === today.getFullYear()
                    ) {
                        if (flag == 1) {
                            for (var i = 0; i < DRCList.length; i++) {
                                if (DRCList[i].startTime != '') {
                                    const [h, m] = DRCList[i].startTime.split(":").map(Number);
                                    const now = new Date();
                                    const currentMinutes = now.getHours() * 60 + now.getMinutes();
                                    const selectedMinutes = h * 60 + m;
                                    if (selectedMinutes < currentMinutes) {
                                        DRCList[i].startTime = ''
                                        this.setState({ DRCList: DRCList })
                                        toastError('Start time cannot be before current time')
                                        err = true
                                        return
                                    }
                                }
                                if (DRCList[i].endTime != '') {
                                    const [h, m] = DRCList[i].endTime.split(":").map(Number);
                                    const now = new Date();
                                    const currentMinutes = now.getHours() * 60 + now.getMinutes();
                                    const selectedMinutes = h * 60 + m;
                                    if (selectedMinutes < currentMinutes) {
                                        DRCList[i].endTime = ''
                                        this.setState({ DRCList: DRCList })
                                        toastError('End time cannot be before current time')
                                        err = true
                                        return
                                    }
                                }
                            }
                        }
                        else {
                            if (scheduleStartTime != '') {
                                const [h, m] = scheduleStartTime.split(":").map(Number);
                                const now = new Date();
                                const currentMinutes = now.getHours() * 60 + now.getMinutes();
                                const selectedMinutes = h * 60 + m;
                                if (selectedMinutes < currentMinutes) {
                                    this.setState({ scheduleStartTime: '' })
                                    toastError('Start time cannot be before current time')
                                    err = true
                                    return
                                }
                            }
                            if (scheduleEndTime != '') {
                                const [h, m] = scheduleEndTime.split(":").map(Number);
                                const now = new Date();
                                const currentMinutes = now.getHours() * 60 + now.getMinutes();
                                const selectedMinutes = h * 60 + m;
                                if (selectedMinutes < currentMinutes) {
                                    this.setState({ scheduleEndTime: '' })
                                    toastError('End time cannot be before current time')
                                    this.setState({})
                                    err = true
                                    return
                                }
                            }
                        }
                    }
                }
            }
            if (diffDays == 0) {
                if (flag == 1) {
                    for (var i = 0; i < DRCList.length; i++) {
                        if (DRCList[i].startTime != '' && DRCList[i].endTime != '') {
                            if (DRCList[i].startTime > DRCList[i].endTime) {
                                // setTimeout(() => {
                                if (mode == 1) {
                                    DRCList[i].startTime = ''
                                    this.setState({ DRCList: DRCList })
                                    toastError('Start time cannot be more than End time')
                                    // err = true
                                } else if (mode == 2) {
                                    DRCList[i].endTime = ''
                                    this.setState({ DRCList: DRCList })
                                    toastError('End time cannot be less than Start time')
                                    // err = true
                                }
                                // }, 200);
                            }
                        }
                    }
                } else {
                    if (scheduleStartTime != '' && scheduleEndTime != '')
                        if (scheduleStartTime > scheduleEndTime) {
                            // setTimeout(() => {
                            if (mode == 1) {
                                // setTimeout(() => {
                                this.setState({ scheduleStartTime: '' })
                                this.setState({ onhighTime: true })
                                // }, 600);
                                toastError('Start time cannot be more than End time')
                                err = true
                                resolve(true)
                            } else if (mode == 2) {
                                // setTimeout(() => {
                                this.setState({ scheduleEndTime: '' })
                                this.setState({ onhighTime: true })

                                // }, 600);
                                toastError('End time cannot be less than Start time')
                                err = true
                                resolve(true)
                            }
                            // }, 200);
                        }
                }

            }
            setTimeout(() => {

                resolve(err)
            }, 200);
        })
    }

    render() {
        const { isLoading, vendorList, specificPersonList, hallList, isOpen, title, fromDate, toDate, preAlertTime, scheduleStartTime, scheduleEndTime, scheduleTimeList, areaSelect, rPersonToggle, rPersonID, DRCList, titleErr, fromDateErr, toDateErr, preAlertTimeErr, scheduleTimeListErr, hallListErr, rPersonIDErr, DRCListErr, } = this.state
        var totalParents = 0
        for (var i = 0; i < DRCList.length; i++) {
            if (DRCList[i].parentId == null) {

                totalParents = totalParents + 1
            }
        }
        console.log(this.state.selectedspecificPersonList)
        return (
            <>

                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <HeaderWithLogo />
                {/* <HeaderWithLogo /> */}
                <>
                    <AdminDrawer />
                    {/* <div className="app-content with-dr-container com-height"> */}

                    <div className="main-content app-content mt-0">
                        <div className="app-content with-dr-container com-height">
                            <div className="main-container">
                                <div className="row m-0">
                                    <div className="breadcrumb-scroll-fixed">
                                        <div className="position-relative">
                                            <h6 className="mb-0 p-2 text-white">Daily Routine Checklist Setup</h6>
                                        </div>
                                    </div>
                                </div>
                                <main id="main" className="py-2 px-3 admin-top-space-add-routine">
                                    <section className="section p-0">
                                        <div class="row py-2">
                                            <div class="col-md-3">
                                                <label class="">Activity<span className="text-red">*</span></label>
                                                <input type="text" class="form-control" value={title} onChange={(e) => this.setState({ title: e.target.value, titleErr: '' })} />
                                                {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                        {titleErr}
                                                    </span>
                                                }
                                            </div>
                                            <div class="col-md-3">
                                                <label >From Date<span className="text-red">*</span></label>
                                                <DatePicker className="form-control"
                                                    dateFormat="dd-MM-yyyy"
                                                    selected={fromDate != '' && fromDate != null ? new Date(fromDate) : ''}
                                                    // onChange={(e) => this.onExpiryAUChange(e)}
                                                    onChange={(e) => this.setState({
                                                        fromDate: e, fromDateErr: ''
                                                    })}
                                                    maxDate={new Date(toDate)}
                                                    minDate={new Date()}
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    placeholderText="dd-mm-yyyy"
                                                />                                {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                        {fromDateErr}
                                                    </span>
                                                }     </div>

                                            <div class="col-md-3">
                                                <label class="">To Date<span className="text-red">*</span></label>
                                                <DatePicker className="form-control"
                                                    dateFormat="dd-MM-yyyy"
                                                    selected={toDate != '' && toDate != null ? new Date(toDate) : ''}
                                                    // onChange={(e) => this.onExpiryAUChange(e)}
                                                    onChange={(e) => this.setState({
                                                        toDate: e, toDateErr: ''
                                                    })}
                                                    minDate={fromDate != '' && fromDate != null ? new Date(fromDate) : new Date()}
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    placeholderText="dd-mm-yyyy"
                                                />{
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                        {toDateErr}
                                                    </span>
                                                }
                                            </div>
                                            <div class="col-md-3">
                                                <label class="">Pre-Alert Time (min)<span className="text-red">*</span></label>
                                                <input type="number" class="form-control" value={preAlertTime} onChange={(e) => this.setState({ preAlertTime: e.target.value, preAlertTimeErr: '' })} />
                                                {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                        {preAlertTimeErr}
                                                    </span>
                                                }
                                            </div>
                                            <div class="col-md-3">
                                                {/* <div class="col-md-12"> */}
                                                <label class="form-label fw-semibold">Schedule Time<span className="text-red">*</span></label>
                                                <div class="input-group">
                                                    <input type="time" id="time1" class="form-control" value={scheduleStartTime} placeholder="Start time" onChange={(e) => this.setState({ scheduleStartTime: e.target.value, })} onBlur={() => this.checkTime(1)} />
                                                    <input type="time" id="time2" class="form-control" placeholder="End time (optional)" value={scheduleEndTime} onChange={(e) => this.setState({ scheduleEndTime: e.target.value })} onBlur={() => this.checkTime(2)} />
                                                    <button class="btn" type="button" style={{ border: "1px solid #dee2e6" }} onClick={() => this.onAddScheduleTime()}>Add</button>
                                                </div>
                                                {scheduleTimeList.length > 0 && <div id="timeList" class="mt-3 text-left">
                                                    {scheduleTimeList.length > 0 && scheduleTimeList.map((item, i) => (
                                                        <div class="badge bg-light text-dark border me-2 p-2 d-inline-flex align-items-center">{item.scheduleStartTime != null && item.scheduleStartTime != '' ? `${item.scheduleStartTime} - ${item.scheduleEndTime}` : item.scheduleEndTime}<span class="text-danger" style={{ cursor: 'pointer', marginLeft: '8px' }} onClick={() => this.onRemoveScheduleTime(i)} >✕</span></div>
                                                    ))}
                                                </div>}
                                                {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                        {scheduleTimeListErr}
                                                    </span>
                                                }
                                                {/* </div> */}
                                            </div>
                                        </div>
                                        {console.log(scheduleEndTime)}
                                        {/* <div class="row mt-2">
                                    <div class="col-md-3">
                                        <div class="col-md-12">
                                            <label class="form-label fw-semibold">Schedule Time<span className="text-red">*</span></label>
                                            <div class="input-group">
                                                <input type="time" id="time1" class="form-control" value={scheduleStartTime} placeholder="Start time" onChange={(e) => this.setState({ scheduleStartTime: e.target.value })} onBlur={() => this.checkTime(1)} />
                                                <input type="time" id="time2" class="form-control" placeholder="End time (optional)" value={scheduleEndTime} onChange={(e) => this.setState({ scheduleEndTime: e.target.value })} onBlur={() => this.checkTime(2)} />
                                                <button class="btn" type="button" style={{ border: "1px solid #dee2e6" }} onClick={() => this.onAddScheduleTime()}>Add</button>
                                            </div>
                                            {scheduleTimeList.length > 0 && <div id="timeList" class="mt-3 text-left">
                                                {scheduleTimeList.length > 0 && scheduleTimeList.map((item, i) => (
                                                    <div class="badge bg-light text-dark border me-2 p-2 d-inline-flex align-items-center">{item.scheduleEndTime != null && item.scheduleEndTime != '' ? `${item.scheduleStartTime} - ${item.scheduleEndTime}` : item.scheduleStartTime}<span class="text-danger" style={{ cursor: 'pointer', marginLeft: '8px' }} onClick={() => this.onRemoveScheduleTime(i)} >✕</span></div>
                                                ))}
                                            </div>}
                                            {
                                                <span className="text-danger text-start text-left d-block mt-1">
                                                    {scheduleTimeListErr}
                                                </span>
                                            }
                                        </div>
                                    </div>
                                </div> */}

                                        {hallList.length > 0 && <div class="row mt-2">
                                            <div class="col-md-12">
                                                <div class="mb-3">
                                                    <label class="form-label d-block">Area (You can select multiple area)<span className="text-red">*</span></label>
                                                    <div class="d-flex flex-wrap align-items-center rounded-1 p-0 py-2" style={{ border: "1px solid #ddd" }} >
                                                        {hallList.map(item => (
                                                            <div class="form-check hall-width mx-3">
                                                                <input class="form-check-input" type="checkbox" checked={item.isSelect} value={item.HallId} onClick={() => this.oncheckHall(item.HallId)} />
                                                                <label class="form-check-label">{item.HallName}</label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>

                                            </div>
                                            {
                                                <span className="text-danger text-start text-left d-block mt-1">
                                                    {hallListErr}
                                                </span>
                                            }
                                        </div>}


                                        <div class="row">
                                            <div class="col-md-4">
                                                <label class="form-label d-block">Responsible Person<span className="text-red">*</span></label>
                                                <div class="d-flex align-items-center gap-3">
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="radio" value={rPersonToggle} checked={rPersonToggle == 1} onClick={() => this.setState({ rPersonToggle: 1, rPersonIDErr: '' })} />
                                                        <label class="form-check-label" for="hallManager">Hall Manager</label>
                                                    </div>
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="radio" value={rPersonToggle} checked={rPersonToggle == 2} onClick={() => this.setState({ rPersonToggle: 2, rPersonIDErr: '' })} />
                                                        <label class="form-check-label" for="specificPerson">Specific Person</label>
                                                    </div>
                                                </div>
                                                {rPersonToggle == 2 && <div class="mt-2" >
                                                    <Select
                                                        options={specificPersonList.map((data) => ({ label: `${data.Name} - ${data.RoleName}`, value: data.Userid }))}
                                                        value={this.state.selectedspecificPersonList}
                                                        onChange={(e) => this.setState({ selectedspecificPersonList: e, rPersonIDErr: '' })}
                                                        isMulti
                                                    />
                                                    {/* <select
                                                className="form-control form-control-sm w-100"
                                                id="roledb"
                                                style={{ textAlign: "left" }}
                                                value={rPersonID}
                                                // disabled={isView || isReadOnly}
                                                onChange={(e) => this.setState({ rPersonID: e.target.value, rPersonIDErr: '' })}
                                            >
                                                <option value="">Select</option>
                                                {specificPersonList.length > 0 && specificPersonList.map((data) => (
                                                    <option key={data.Userid} value={data.Userid}>{data.Name} - {data.RoleName}</option>
                                                ))}
                                            </select> */}
                                                </div>}
                                                {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                        {rPersonIDErr}
                                                    </span>
                                                }
                                            </div>

                                        </div>

                                        <div class="row m-0 mt-3">
                                            <div class="d-flex justify-content-between align-items-center mb-2 p-0">
                                                <h6 class="mb-0 pb-0">Checklist Section {
                                                    <span className="text-danger fw-normal text-start text-left d-block mt-1">
                                                        {DRCListErr}
                                                    </span>
                                                }</h6>

                                                <button onClick={() => this.addMainTask()} class="btn text-white" style={{ backgroundColor: '#51cbc0' }} >Add Task</button>
                                            </div>

                                            <table class="table table-bordered" id="checklistTable">
                                                <thead class="table-light">
                                                    <tr>
                                                        <th style={{ width: '50px' }}>Sr. No.</th>
                                                        <th>Checklist Description<span className="text-red">*</span></th>
                                                        <th>Additional Instruction</th>
                                                        <th style={{ width: '200px' }}>Service Partner<span className="text-red">*</span></th>
                                                        <th style={{ width: '130px' }}>Start Time<span className="text-red">*</span></th>
                                                        <th style={{ width: '120px' }}>End Time<span className="text-red">*</span></th>
                                                        <th style={{ width: '200px' }}>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {DRCList.length > 0 && DRCList.map((item, i) => (
                                                        <tr data-row="1">
                                                            <td class="sr-no">{item.srno}</td>
                                                            <td><textarea class="form-control" rows="2" value={item.desc} onChange={(e) => this.editChecklist(e.target.value, i, 0)}></textarea></td>
                                                            <td><textarea class="form-control" rows="2" value={item.addInt} onChange={(e) => this.editChecklist(e.target.value, i, 1)}></textarea></td>
                                                            <td><select
                                                                className="form-control form-control-sm w-100"
                                                                id="roledb"
                                                                style={{ textAlign: "left" }}
                                                                value={item.AccountID}

                                                                // disabled={isView || isReadOnly}
                                                                onChange={(e) => this.editChecklist(e.target.value, i, 4)}
                                                            >
                                                                <option value="">Select</option>
                                                                {vendorList.length > 0 && vendorList.map((data) => (
                                                                    <option key={data.AccountID} value={data.AccountID}>{data.CompanyName}</option>
                                                                ))}
                                                            </select></td>
                                                            <td><input type="time" id="time1" class="form-control" value={item.startTime} onBlur={() => this.checkTime(1, 1)} placeholder="Start time" onChange={(e) => this.editChecklist(e.target.value, i, 2)} /></td>
                                                            <td><input type="time" id="time1" class="form-control" value={item.endTime} placeholder="Start time" onChange={(e) => this.editChecklist(e.target.value, i, 3)} onBlur={() => this.checkTime(2, 1)} /></td>
                                                            <td>
                                                                {item.parentId == null && <button class="btn btn-aqua add-child mx-2" onClick={() => this.addSubTask(item.srno)}>Add Sub Task</button>}
                                                                {item.parentId != null ? <button class="btn btn-outline-danger btn-sm delete-row" onClick={() => this.onDeleteChecklist(i, item.parentId == null ? 0 : 1)}>Delete</button> : totalParents > 1 ? <button class="btn btn-outline-danger btn-sm delete-row" onClick={() => this.onDeleteChecklist(i, item.parentId == null ? 0 : 1)}>Delete</button> : <></>}
                                                            </td>
                                                        </tr>
                                                    ))
                                                    }
                                                </tbody>
                                            </table>
                                        </div>






                                        <div class="row my-3 mt-0">
                                            <div class="d-flex justify-content-end">
                                                <button class="btn btn-aqua px-3 p-1 mx-2 w-auto" onClick={() => this.insertUpdateDRC()}>Submit</button>

                                                <button class="btn btn-gray px-3 p-1 w-auto" onClick={() => this.props.navigate('/dailyRoutineChecklistList')}>Back</button>
                                            </div>
                                        </div>




                                        {/* <style>
                                    label {
                                        font - size: 13px !important;
        }

                                    .form-control {
                                        font - size: 13px;
        }
                                </style> */}

                                    </section>
                                </main>
                            </div>
                        </div>
                    </div>
                </>
            </>
        )
    }
}


export default withRouter(connect(null, {
    fill_action,
    insertUpdateDRC_action, getDRCDetails_action
})(DailyRoutineChecklistSetup));